import { motion } from 'framer-motion';
import { Crown, Gem, Diamond, Sparkles } from 'lucide-react';
import { SHOWS } from '../lib/shows';
import { STAGE_THEMES } from '../lib/stageThemes';

const JEWELS = [Crown, Gem, Diamond, Sparkles];

export function ShowSchedule({ selectedId, autoShowId, status, onSelect }) {
  return (
    <section className="border-t border-white/10 bg-[#050505] px-6 py-28 md:px-16 lg:px-24" data-testid="show-schedule">
      <div className="mx-auto max-w-6xl">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        >
          <p className="text-xs uppercase tracking-[0.35em] text-[#D4AF37]">The daily stage</p>
          <h2 className="font-serif-lux mt-4 max-w-xl text-4xl font-medium text-[#F5F5F5] lg:text-5xl">
            Four shows. Four colours. One crown.
          </h2>
        </motion.div>

        <div className="mt-16 grid gap-px border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-4">
          {SHOWS.map((show, i) => {
            const theme = STAGE_THEMES[show.theme];
            const Jewel = JEWELS[i % JEWELS.length];
            const isAuto = show.id === autoShowId;
            const isSelected = show.id === selectedId;
            return (
              <motion.button
                key={show.id}
                type="button"
                onClick={() => onSelect(show.id)}
                className="group relative bg-[#0A0A0A] p-8 text-left transition-colors duration-300 hover:bg-[#111111]"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
                data-testid={`show-card-${show.id}`}
              >
                <span
                  className="absolute inset-x-0 top-0 h-[3px] transition-opacity duration-300"
                  style={{
                    backgroundColor: theme.primary,
                    opacity: isSelected ? 1 : 0.35,
                    boxShadow: isSelected ? `0 0 16px ${theme.glow}` : 'none',
                  }}
                />
                <span
                  className="jewel-anim absolute right-6 top-6"
                  style={{ animationDelay: `${i * 0.7}s, ${i * 0.5}s`, color: theme.ring }}
                  data-testid={`show-jewel-${show.id}`}
                >
                  <Jewel className="h-7 w-7" strokeWidth={1.5} />
                </span>
                <span className="font-display block text-3xl text-[#F5F5F5] transition-colors duration-300 group-hover:text-white">
                  {show.label}
                </span>
                <span className="mt-2 block text-xs uppercase tracking-[0.2em]" style={{ color: theme.ring }}>
                  {theme.name}
                </span>
                <span className="mt-6 block text-[11px] uppercase tracking-[0.2em] text-[#666666]">
                  {isAuto && status === 'live'
                    ? '● Live now'
                    : isAuto
                      ? 'Up next'
                      : 'Today'}
                </span>
              </motion.button>
            );
          })}
        </div>
        <p className="mt-6 text-xs text-[#666666]">
          Select a show to open the live draw stage.
        </p>
      </div>
    </section>
  );
}
